// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"CompletionModal_modalBody__3d7KI","secondSection":"CompletionModal_secondSection__2Oljq"};